import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {News} from "../../moderator/components/add-edit-news/model/news";

@Injectable()
export class NewsSharedService {
  constructor(private _http: HttpClient) {
  }

  getNewsContent(newsId: number) {
    return this._http.post<News>('api/s/news/get', newsId);
  }

  getNewsImage(newsId: number, fileId: string) {
    return this._http.get(`api/s/news/getImage/${newsId}/${fileId}`, {responseType: 'blob'});
  }

  getNewsAuthorAvatar(newsId: number, fileId: string) {
    return this._http.get(`api/s/news/getAuthorAvatar/${newsId}/${fileId}`, {responseType: 'blob'});
  }

  getLastNews() {
    return this._http.get<any[]>('api/s/news/getLastNews');
  }

  getPopularNews() {
    return this._http.get<any[]>('api/s/news/getPopularNews');
  }

  getTagsList() {
    return this._http.get<any[]>('api/s/news/getTagsList');
  }

  getTagInfo(params) {
    return this._http.post<any>('api/s/news/getTagInfo', params);
  }

  getSavedNews() {
    return this._http.get<any[]>('api/s/news/getSavedNews');
  }

  getPublishedNews() {
    return this._http.get<any[]>('api/s/news/getPublishedNews');
  }

  getArchivedNews() {
    return this._http.get<any[]>('api/s/news/getArchivedNews');
  }

  getNewsListByStatus(params) {
    return this._http.post<any>('api/s/news/list', params);
  }

  addNewComment(params) {
    return this._http.post<any>('api/s/news/addComment', params);
  }

  deleteComment(params) {
    return this._http.post<any>('api/s/news/deleteComment', params);
  }

  editComment(params) {
    return this._http.post<any>('api/s/news/editComment', params);
  }

  searchText(params) {
    return this._http.post<any>('api/s/news/search', params);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/services/news-shared.service.ts